module.exports = __webpack_public_path__ + "img/articleBrowser.dd881a25.png";